import { AxiosResponse } from "axios";
import API from "../api";

import { FleetType } from "../models/fleet.type";

const ROUTE_NAME = "types/fleets";

const FleetTypeService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<FleetType>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<FleetType[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(fleetType: FleetType): Promise<AxiosResponse<FleetType>> {
    return await API.post(`/${ROUTE_NAME}`, fleetType);
  },
  async update(id: number, fleetType: FleetType): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, fleetType);
  },
  async delete(id: number): Promise<AxiosResponse<FleetType>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default FleetTypeService;
